<template>
<div class="home-admin">
  <md-progress-bar md-mode="indeterminate" v-if="loading"/>
  <div class="home-admin__dash">

    <!-- <div class="home-admin__indicators">
      <div class="pie-loading" v-if="loading">
        <vue-content-loading
          :width="360" :height="270"
          primary="#fff"
          secondary="#eceff8">
          <rect x="0" y="0" width="360" height="270"/>
        </vue-content-loading>
      </div>
      <div id="piechart"></div>

      <div class="home-admin__items">
        <ItemAdmin :type="'Type1'" content="$50,000"/>
        <ItemAdmin :type="'Type2'" content="$1,250"/>
        <ItemAdmin :type="'Type3'" content="+2.0%"/>
      </div>
    </div> -->

    <div class="home-admin__search">
      <md-autocomplete v-model="selectedCompany" :md-options="empresas">
        <label>Empresa</label>
      </md-autocomplete>
    </div>
    
  </div>

  <div class="home-admin__separator"></div>
</div>
</template>

<script>
import ItemAdmin from '@/components/admin/ItemAdmin'
import {mapGetters, mapActions} from 'vuex'

import VueContentLoading from 'vue-content-loading'


export default {
  components: {
    ItemAdmin,
    VueContentLoading
  },
  created(){
    this.getClients().then(()=>{
      this.companies.forEach(element => {
        this.empresas.push(element.name)
      })
    })
  },
  mounted(){
    // google.charts.load('current', {'packages':['corechart']})
    // google.charts.setOnLoadCallback(this.drawChart)
    this.loading = false
  },

  data() {
    return {
      search: '',
      loading: true,
      selectedCompany: null,
      empresas: []
    }
  },

  computed: {
    ...mapGetters({
      companies: 'listBusiness'
    })
  },

  methods: {
    ...mapActions({
      getClients: 'getBusiness'
    }),

    drawChart(){
      var data = google.visualization.arrayToDataTable([
        ['Tamaño Empresa', 'Cantidad'],
        ['Pequeña', 60],
        ['Mediana', 30],
        ['Grande', 10]
      ])
      var options = {
        title: 'Clientes',
        colors: ['#55D8FE','#FFDA83','#FF8373'],
        is3D: true
      }
      var chart = new google.visualization.PieChart(document.getElementById('piechart'))
      chart.draw(data, options)
      this.loading = false
    }
  }
}
</script>

<style lang="scss" scoped>
//1-SETTINGS
//colors
$b-orange: #d8ff00;
$b-blue: #000000;
$b-emph: #97c2c9;
$b-blue-dark: #C63832;
//breakpoints
$sm: 600px;
$md: 900px;
$lg: 1200px;
$xl: 1800px;
//variables
$p-img: '../assets/img/';

//2-VENDORS

//3-TOOLS
//functions
//background-image function
@function bimg($img){
  @return url($p-img+$img);
}
//mixins
@mixin mqwh($min-width,$max-height){
  @media (min-width: $min-width) and (max-height: $max-height){
    @content;
  }
}

@mixin mq($min-width){
  @media screen and (min-width: $min-width){
    @content;
  }
}

//8-TRUMPS
#piechart,.pie-loading{
  width: 360px;
  height: 270px;
  // margin: 0 auto;
  border-radius: .6rem;
  overflow: hidden;
  @include mq($md){
    height: 291px;
  }
  @include mq($lg){
    width: 540px;
    height: 360px;
  }
}

.home-admin{
  background-color: #ECEFF8;
  &__indicators{
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    @include mq('700px'){
      flex-direction: row;
      justify-content: center;
    }
    &>*{
      margin: 0 auto;
      @include mq('700px'){
        margin: 0 .5rem;
      }
    }
    @include mq('700px'){

    }
  }
  &__items{
    display: flex;
    flex-direction: column;
    margin-top: .5rem;
    &>*{
      margin: .5rem 0;
      @include mq('700px'){
        margin: 0;
      }
    }
    @include mq('700px'){
      margin-top: 0;
      justify-content: space-between
    }
  }

  &__search{
    background-color: #fff;
    width: 20rem;
    margin: 2rem auto;
    margin-top: .5rem;
    padding: .6rem 1rem;
    height: 5rem;
    border-radius: 6px;
    @include mq("700px"){
      width: calc(360px + 1rem + 20rem);
      margin-top: 1rem;
    }
    @include mq($md){
      width: calc(360px + 1rem + 16rem);
    }
    @include mq($lg){
      width: calc(540px + 1rem + 20rem);
    }
  }

  &__separator{
    border: 1px solid rgba(#000000,.34);
  }
}
</style>
